import { Outlet } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import CookieConsent from "@/components/CookieConsent";
import SmoothScroll from "@/components/SmoothScroll";
import ChatWidget from "@/components/ChatWidget";

export default function MarketingLayout() {
  return (
    <SmoothScroll>
      <div className="min-h-screen bg-lightbg flex flex-col">
        <Header />
        <main className="flex-1">
          <Outlet />
        </main>
        <Footer />
        <CookieConsent />
        <ChatWidget />
      </div>
    </SmoothScroll>
  );
}
